module.exports = __webpack_public_path__ + "media/images/vp/samples/23-f269408695a960637d55cd4be5c7907d.jpg";